// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Analytics_buttonsContainer__j3N-m","containerImg":"Analytics_containerImg__gmLxw","restaurantCard":"Analytics_restaurantCard__QA1G0"};